export default "__VITE_ASSET__c1626275__"